// You may start using jQuery $ immediately after this file is loaded
import $ from "jquery";
console.log("This is main.js");

import '@splidejs/splide/css';

import "./js/menu.js";
import "./js/pages.js";
// import "./js/activity.js";
import "./js/modal.js";
import "./js/api.js";
// import "./js/login.js";
// import "./js/register.js";
// import "./js/forgot-password.js";
// import "./js/profile.js";
// import "./js/reset-password.js";
// import "./js/register-event.js";
import "./js/new-activity.js";


jQuery(function () {
  console.log("Ready");

  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('a[href*="#"]:not([href="#"]):not(.sf-dump-toggle)').on(
    "click",
    function () {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          );

          target.trigger("focus");
          return false;
        }
      }
    }
  );
  if (window.location.hash) {
    // Smoothly scroll to the target anchor
    $("html, body").animate(
      {
        scrollTop: $(window.location.hash).offset().top,
      },
      1000
    );
  }
  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////



